import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Collapse, IconButton,
} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import {
  FindLoad, SendPageSave, useGlobalStyles, SavePage,
  FindSuccessItem, SaveParams, handleReturnAgingColor,
} from 'utils';
import {
  SearchAndFilter, PaginationItem, Loader,
  TableNoInfo, DateSelector,
} from 'components';
import { tableStyle } from './styles';
import { filterFromTable, handleReturnColor } from './constants';
import { CANCELLED } from '../../pages/accounting/constants';
import { useDebouncedCallback } from 'use-debounce';

export const FullTableAccordion = ({
                                     head,
                                     body,
                                     list,
                                     loadingType,
                                     handleClick,
                                     noText,
                                     dateFilter,
                                     margin,
                                     listCount,
                                     handleClickButton,
                                     height,
                                     fixHeight,
                                     defaultType,
                                     clickType,
                                     padding,
                                     paddingHead,
                                     renderDetails,
                                     limitCount,
                                     handleRowClick,
                                     currentOpeningAccordionId,
                                   }) => {
  const classes = tableStyle();
  const globalStyle = useGlobalStyles();
  const history = useHistory();
  const info = history?.location?.state;
  const loader = FindLoad(loadingType || '');
  const miniLoadSuccess = FindSuccessItem('MINI_LOAD');
  const [listInfo, setListInfo] = useState(list);
  const [backSearched, setBackSearched] = useState({ searchKey: '', searchValue: '' });
  const [searched, setSearched] = useState({ name: '', text: '' });
  const [openRow, setOpenRow] = useState(null);
  const location = useLocation();
  const containerRef = useRef(null);


  useEffect(() => {
    if (list && !searched?.value) {
      setListInfo(list);
    }
  }, [list]);

  useEffect(() => {
    if (info?.searchKey) {
      setBackSearched({
        searchKey: info?.searchKey,
        searchValue: info?.searchValue,
      });
    }
  }, [info]);

  useEffect(() => {
    if (defaultType) {
      const anotherInfo = { ...info };
      anotherInfo.type = defaultType;
      SavePage(history, info, anotherInfo);
    }
  }, []);

  const scrollToRow = (id) => {
    const container = containerRef.current;
    if (!container || !id) return;

    const row = document.getElementById(`row-${id}`);
    if (!row) return;


    container.scrollTo({
      top: row.offsetTop - 85 - 60,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (!openRow) return;
    const t = setTimeout(() => scrollToRow(openRow), 220);
    return () => clearTimeout(t);
  }, [openRow]);

  const toggleRow = (id) => {

    if (handleRowClick) {
      handleRowClick(id);
    }
    setOpenRow(prevId => prevId === id ? null : id);
    currentOpeningAccordionId?.(openRow === id ? null : id);
  };

  const changePage = (number) => {
    setSearched({ name: '', text: '' });
    SendPageSave(number, info, history, limitCount);
  };

  const debounced = useDebouncedCallback((name, value, searchKey) => {
    const params = { ...info, limit: limitCount || 100, skip: 0, page: 1 };
    if (value) {
      params.searchKey = searchKey;
      params.searchValue = value;
    } else {
      delete params.searchKey;
      delete params.searchValue;
    }
    SaveParams(history, params);
  }, 1000, { maxWait: 2000 });

  const handleChange = (e, nameRow, searchKey, type) => {
    if (searchKey) {
      setBackSearched({
        searchKey: searchKey,
        searchValue: e.target.value,
      });
      debounced(e.target.name, e.target.value, searchKey);
    } else {
      setSearched({
        name: e.target.name,
        value: e.target.value,
      });

      if (e.target.name) {
        if (!e.target.value) {
          setListInfo(list);
        } else {
          const info = filterFromTable(e, nameRow, list, type);
          setListInfo(info);
        }
      }
    }
  };

  const handleName = (item, name) => {
    handleClickButton(item, name);
  };

  const renderItems = (i, item) => {
    if (item) {
      if (item?.button) {
        return item.button(name => handleName(i, name), i, miniLoadSuccess?.data === i.id);
      } else {
        return item.rowText(i);
      }
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {dateFilter && (
        <DateSelector
          startName={dateFilter?.startName || 'startDate'}
          endName={dateFilter?.endName || 'endDate'}
        />
      )}
      <div
        style={{ margin: margin ? 0 : '', height: fixHeight || '' }}
        className={
          height === 'small'
            ? globalStyle.tableWrapperSmall
            : height === 'medium'
              ? globalStyle.tableWrapperMedium
              : globalStyle.tableWrapper
        }
      >
        <TableContainer
          ref={containerRef}
          component={Paper}
          className={
            height === 'small'
              ? globalStyle.tableContainerSmall
              : height === 'medium'
                ? globalStyle.tableContainerMedium
                : globalStyle.tableContainer
          }
        >
          <Table stickyHeader aria-label='sticky table' style={{ position: 'relative' }}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                {head?.map((i, j) => (
                  i && (
                    <TableCell
                      key={j}
                      style={
                        i?.width
                          ? { width: i.width }
                          : paddingHead
                            ? { padding: paddingHead }
                            : {}
                      }
                    >
                      {i?.renderView ? (
                        <div>{i.renderView}</div>
                      ) : (
                        <SearchAndFilter
                          handleSearch={(e) =>
                            handleChange(e, i.nameRow, i.searchKey, i.icon)
                          }
                          item={i}
                          searched={searched}
                          backSearched={backSearched}
                        />
                      )}
                    </TableCell>
                  )
                ))}

                <TableCell />
              </TableRow>
            </TableHead>

            {loader?.length ? (
              <div style={{ position: 'absolute', width: '100%' }}>
                <Loader height={fixHeight ? `calc(${fixHeight} - 85px)` : ''} />
              </div>
            ) : (
              <TableBody>
                {listInfo?.length ? (
                  <>
                    {listInfo.map((i, j) => (
                      <React.Fragment key={j}>
                        <TableRow
                          // onClick={() => toggleRow(i.id)}
                          className={classes.tableRow}
                        >
                          {body?.map((item, ke) => (
                            <TableCell
                              onClick={() => {
                                !item?.notClickable && toggleRow(i.id);
                              }}
                              key={ke}
                              style={{
                                opacity: i?.status === CANCELLED ? '0.5' : '',
                                background: item.type === 'returnColor' ? handleReturnAgingColor(i?.bill?.lastInvoiceDate, i?.customer?.pmtTerm)
                                  : 'transparent',
                                textAlign: item.type === 'returnColor' ? 'center' : '',
                                color: '#51566D',
                                borderLeft:
                                  ke === 0
                                    ? i?.isVerification || i?.isRevision || (location?.pathname === '/processing' && i?.doNotPay)
                                      ? '5px solid #D72525'
                                      : ''
                                    : '',
                                padding: padding || item?.padding || '',
                                height: 'inherit',
                              }}
                            >
                              {renderItems(i, item) || 'Not Set'}
                            </TableCell>
                          ))}

                          <TableCell padding='checkbox'>
                            <IconButton size='small'>
                              {openRow === i?.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                          </TableCell>
                        </TableRow>

                        <TableRow id={`row-${i?.id}`}>
                          <TableCell colSpan={body.length + 1} style={{ padding: 0, paddingTop: 0 }}>
                            <Collapse
                              in={openRow === i?.id}
                              timeout='auto'
                              unmountOnExit
                              onEnter={() => scrollToRow(i?.id)}
                            >
                              {renderDetails ? renderDetails(i) : ''}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}

                    <TableRow>
                      <TableCell colSpan={body.length + 1} style={{ height: 80, border: 'none' }} />
                    </TableRow>
                  </>
                ) : (
                  <div style={{ height: '100px' }}>
                    <TableNoInfo text={`No ${noText} Yet`} />
                  </div>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {listCount > 0 && (
          <div style={{ background: 'white', borderRadius: '0 0 8px 8px' }}>
            <PaginationItem
              limitCount={limitCount}
              listInfo={listInfo}
              handleReturn={changePage}
              count={listCount}
              styles={{ margin: '0 0 21px 0' }}
              loader={loader}
            />
          </div>
        )}
      </div>
    </div>
  );
};
